import React, { useEffect, useState, useRef, useContext } from 'react';
import Pusher from 'pusher-js'; // 1. Cambiamos la importación
import './AdminPanel.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import PedidosLista from './PedidosLista';
import Sidebar from './Sidebar'; 
import PedidosView from "./PedidosView";
import ClientesView from "./ClientesView"; 
import PagosView from "./PagosView"; 
import PedidoCard from './PedidoCard';
import { ESTADOS_PEDIDO, ESTADOS_PERMITIDOS } from '../shared/utils/estadosPedido';
import { GRUPOS_ESTADOS } from '../shared/utils/estadosPedido';

export default function AdminPanel() {
  // --- CONTEXTO Y NAVEGACIÓN ---
  const { logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  // --- IDENTIDAD (100% CONTEXTO, 0% LOCALSTORAGE) ---
  const token = user?.token; 
  const nombre = user?.nombre || 'Admin';
  // Centralizamos el ID del admin aquí:
  const miAdminId = user?.uuid || user?.id || null; 

  // --- ESTADOS DE UI ---
  const [usuariosConectados, setUsuariosConectados] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modo, setModo] = useState("night"); 
  const [vista, setVista] = useState("dashboard");
  const [pagoPendienteGlobal, setPagoPendienteGlobal] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  const [confirmaciones, setConfirmaciones] = useState([]);
  const [filtro, setFiltro] = useState('pendientes'); 
  const [pedidoExpandidoId, setPedidoExpandidoId] = useState(null);
  const [clienteIdBuscado, setClienteIdBuscado] = useState('');
  const [openPedidos, setOpenPedidos] = useState(true);

  // REFS
  const mapaClientesRef = useRef({});
  const pusherRef = useRef(null); 
  const channelRef = useRef(null);
  // Mantenemos adminUUID como REF solo si necesitas pasarlo a componentes que no usan Context
  const adminUUID = useRef(miAdminId);

  // Sincronizar el REF si el context cambia
  useEffect(() => {
    adminUUID.current = miAdminId;
  }, [miAdminId]);

  // --- LÓGICA DE CIERRE DE PEDIDO ---
  async function moverPedidoACompletados(id, modoEntrega) {
    if (!token || !miAdminId) return;

    // Revisar actualmente no esta en uso ......
    
    try {
      const response = await fetch("http://localhost:5000/api/admin/cierre", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          pedido_id: id,
          admin_id: miAdminId,
          motivo: "Pedido cerrado desde panel"
        })
      });

      const data = await response.json();
      if (!data.success) return;

      const nuevoEstado = modoEntrega === "delivery" ? ESTADOS_PEDIDO.COMPLETADO : ESTADOS_PEDIDO.CERRADO;

      setPedidos(prev => prev.map(p => 
        String(p.id) === String(id) 
          ? { ...p, cerrado_por_admin: true, estado: nuevoEstado, admin_id: miAdminId }
          : p
      ));

    } catch (error) {
      console.error("❌ Error en cierre:", error);
    }
  }

  // --- LOGOUT LIMPIO ---
  const handleLogout = () => {
    if (window.confirm('¿Estás seguro que deseas cerrar sesión?')) {
      logout(); 
      if (pusherRef.current) pusherRef.current.disconnect();
      navigate('/admin-intro', { replace: true });
    }
  }; //////// *----- 1er cambio fin prueba 

// cambiamos hasta este punto la parte 1 

// 3. Actualización de mapa de clientes (Referencia rápida)
const actualizarMapaClientes = (pedido) => {
  const nombreEnvio = pedido?.envio?.nombre;
  if (pedido?.cliente_id && nombreEnvio) {
    mapaClientesRef.current[pedido.cliente_id] = nombreEnvio;
  }
};

// 4. Formateador de pedidos (Crucial para MySQL)
const parsePedidoFields = (pedido, mapaClientes = {}) => {
  let envioObj = pedido.envio;
  let productosObj = pedido.productos;

  // --- 1. NORMALIZACIÓN DE IDENTIFICADORES (Crucial para eliminar el ruido) ---
  // Forzamos que 'id' siempre contenga el identificador único de la DB
  const idUnico = pedido.pedido_id || pedido.id;

  try {
    if (typeof pedido.envio === 'string' && pedido.envio.trim() !== '') {
      envioObj = JSON.parse(pedido.envio);
    }
  } catch (err) {
    console.warn('⚠️ Error al parsear campo "envio":', err.message);
    envioObj = null;
  }

  try {
    if (typeof pedido.productos === 'string' && pedido.productos.trim() !== '') {
      productosObj = JSON.parse(pedido.productos);
    }
  } catch (err) {
    console.warn('⚠️ Error al parsear campo "productos":', err.message);
    productosObj = [];
  }

  // --- 2. NORMALIZACIÓN DE MODO DE ENTREGA (Para el flujo de Retiro) ---
  const modo = (pedido.modo_entrega || 'retiro').toLowerCase();
  
  // Si es retiro y el objeto envío está vacío, le damos una estructura mínima
  // Esto evita que PedidoCard o PedidosLista exploten al leer 'envio.direccion'
  if (modo === 'retiro' && (!envioObj || !envioObj.direccion)) {
    envioObj = { 
      ...envioObj, 
      direccion: 'Retiro en Tienda 🏪', 
      nombre: pedido.cliente_nombre || 'Cliente' 
    };
  }

  // --- 3. NORMALIZACIÓN DE ESTADOS (Tu lógica original optimizada) ---
  let estadoOriginal = (pedido.estado || ESTADOS_PEDIDO.PENDIENTE).toLowerCase();
  let estadoNormalizado = estadoOriginal;

  const equivalencias = {
    'enproceso': ESTADOS_PEDIDO.EN_PROCESO,
    'procesando': ESTADOS_PEDIDO.EN_PROCESO,
    'enruta': ESTADOS_PEDIDO.EN_RUTA,
    'en_camino': ESTADOS_PEDIDO.EN_RUTA,
    'cerradoporcliente': ESTADOS_PEDIDO.CERRADO_POR_CLIENTE,
    'finalizado': ESTADOS_PEDIDO.COMPLETADO,
    'completado': ESTADOS_PEDIDO.COMPLETADO,
    'cerrado': ESTADOS_PEDIDO.CERRADO,
    'rechazado': ESTADOS_PEDIDO.RECHAZADO
  };

  estadoNormalizado = equivalencias[estadoOriginal] || estadoOriginal;

  return {
    ...pedido,
    id: idUnico,        // 👈 ID maestro para React y Filtros
    pedido_id: idUnico, // 👈 ID para peticiones PUT/DELETE al Backend
    envio: envioObj,
    productos: productosObj,
    estado: estadoNormalizado,
    modo_entrega: modo,
    cliente_nombre: mapaClientes[pedido.cliente_id] 
      || pedido.cliente_nombre 
      || pedido.cliente?.nombre 
      || pedido.cliente_id,
    fecha_entrega: pedido.fecha_entrega || pedido.fecha
  };
};
    // revisar para arreglar actualmente el boton no funciona  * REVISAR * ACTUALMENTE NO ESTA EN USO 
    
    const eliminarPedidoDesdeAdmin = async (id) => {
      const confirmacion = window.confirm('¿Estás seguro de que deseas eliminar este pedido pendiente?');
    
      if (!confirmacion) return;
    
      try {
        const res = await fetch(`http://localhost:5000/api/admin/pedidos/${id}`, {
          method: 'DELETE',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` //  Seguridad: Enviamos el token
          },
          body: JSON.stringify({
            motivo: 'Eliminado desde panel admin',
            eliminado_por: nombre, //  Dinámico: Usa el nombre del admin logueado
          }),
        });
    
        // Validamos si la respuesta fue exitosa antes de intentar leer el JSON
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          alert('Error al eliminar: ' + (errorData.error || 'El servidor denegó la petición'));
          return;
        }
    
        const data = await res.json();
    
        if (data.success) {
          // Actualizamos la interfaz eliminando el pedido de la lista local
          setPedidos(prev => prev.filter(p => p.id !== id));
          setPedidoSeleccionado(null);
          console.log(`Pedido ${id} eliminado con éxito por ${nombre}`);
        } else {
          alert('Error al eliminar: ' + data.error);
        }
      } catch (err) {
        console.error("Error en DELETE pedido:", err);
        alert('Error de red al intentar eliminar el pedido.');
      }
    };

  /**
   * NUEVA FUNCIÓN: Inicia el flujo del Delivery Bridge (Admin -> Delivery)
   */
  const onNotificarListoBridge = async (pedidoId) => {
    // 1. Validaciones de seguridad
    if (!adminUUID.current) {
      console.error("Admin UUID no definido.");
      return;
    }
  
    console.log(`[BRIDGE] Admin notificando 'LISTO' para Pedido ${pedidoId} en PHP`);
  
    // 2. Optimismo UI: Cambio inmediato para que el admin vea el badge amarillo
    setPedidos(prevPedidos =>
      prevPedidos.map(p => 
        ((p.id || p.pedido_id) === pedidoId) 
        ? { ...p, estado_bridge: 'LISTO_PARA_RECOGER' } 
        : p
      )
    );
  
    try {
      // 🌐 RUTA HÍBRIDA/DIRECTA: Cambiamos localhost por la ruta absoluta en el dominio real
      const URL_BRIDGE_PROD = "https://clavelinacarnes.com/clavelina-backend-php/src/Routes/delivery/actualizar_bridge.php";

      // 3. Notificación al Backend vía la nueva ruta UNIFICADA en PHP
      const res = await fetch(URL_BRIDGE_PROD, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Mantiene el token del admin
        },
        body: JSON.stringify({
          pedido_id: String(pedidoId), // Aseguramos que viaje como string
          estado_bridge: 'LISTO_PARA_RECOGER',
          observaciones: 'Admin marca como listo para recoger'
        }),
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        throw new Error(data.error || 'Error al notificar al servidor PHP');
      }
  
      console.log(`[Pusher Sync] Backend PHP notificó con éxito el pedido ${pedidoId}`);
  
    } catch (err) {
      console.error("Error en el flujo Bridge con PHP:", err);
      alert("Hubo un problema al notificar al repartidor desde el servidor PHP: " + err.message);
      
      // 4. Rollback: Si falla el servidor, devolvemos el estado a 'EN_PROCESO' 
      // para que el botón de "Avisar" vuelva a aparecer
      setPedidos(prevPedidos =>
        prevPedidos.map(p => 
          ((p.id || p.pedido_id) === pedidoId) 
          ? { ...p, estado_bridge: 'EN_PROCESO' } 
          : p
        )
      );
    }
  };
    
    const cargarPedidosPersistentes = async () => {
      try {
        // 🔄 CAMBIO CRÍTICO: Apuntamos al index.php (vía /api/pedidos) 
        // No apuntes directamente a archivos dentro de /src/
        const res = await fetch('http://localhost/clavelina-backend-php/public/api/pedidos', {
          method: 'GET', // Importante que sea GET
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
    
        if (!res.ok) throw new Error('No se pudo cargar los pedidos desde PHP');
    
        const data = await res.json();
        
        // Tu lógica de parseo y filtros se mantiene exactamente igual
        const parseados = data.map(p => {
           // ... (tu lógica de parsePedidoFields y normalización)
           return p; 
        }).filter(pp => {
           // Filtro por admin_id
           return !pp.admin_id || pp.admin_id === null || String(pp.admin_id) === String(miAdminId); 
        });
    
        setPedidos(parseados);
        return parseados; 
      } catch (err) {
        console.error('❌ Error al cargar pedidos:', err.message);
        return [];
      }
    };
//  useEffect para debuggear:
useEffect(() => {
  console.log("🔍 DEBUG AdminPanel - pagoPendienteGlobal:", pagoPendienteGlobal);
  console.log("🔍 DEBUG AdminPanel - pedidoSeleccionado:", pedidoSeleccionado?.id);
  
  if (pagoPendienteGlobal && pedidoSeleccionado) {
    console.log("🔍 Comparación IDs:", {
      pagoPedidoId: pagoPendienteGlobal.pedido_id,
      pedidoSeleccionadoId: pedidoSeleccionado.id,
      sonIguales: String(pagoPendienteGlobal.pedido_id) === String(pedidoSeleccionado.id)
    });
  }
}, [pagoPendienteGlobal, pedidoSeleccionado]);

// --- EFECTO UNIFICADO DE CONEXIÓN ( para romper  el bucle infinito) ---
useEffect(() => {
  // 🛡️ 1. Guardia de Seguridad: Si no hay usuario o token, no hacemos nada.
  // Esto evita que el componente intente conectar a Pusher con datos nulos.
  if (!user || !token) return;

  // 2. Carga inicial de la base de datos
  cargarPedidosPersistentes();

  // 3. Conectar Pusher
  const pusher = new Pusher('ff59d4da6a1a8c01af49', {
    cluster: 'us2',
    forceTLS: true
  });
  pusherRef.current = pusher;

  const channel = pusher.subscribe('admin-channel');

  // nueva suscripcion // -- puente adicional admin-delivery 
  // Suscribirse también al canal de logística (o cambiar el de arriba)
const adminRoomChannel = pusher.subscribe('admin-room');
  channelRef.current = channel;

  // --- EVENTOS PUSHER ( lógica original la mantenemos -- ) ---


  // --- NUEVA ESCUCHA: Confirmación Final del Cliente (Bridge) ---
  channel.bind('pedido-confirmado-cliente', (data) => {
    console.log("🚨 [BRIDGE] El cliente confirmó recepción:", data);

    // 1. Mostrar notificación visual en el array de confirmaciones (el que ya tienes en tu UI)
    setConfirmaciones(prev => [...prev, {
      pedido_id: data.pedido_id,
      mensaje: "¡Entregado! El cliente confirmó que ya tiene su pedido.",
      tipo: 'success'
    }]);

    // 2. Actualización de la lista de pedidos en tiempo real
    setPedidos(prev => prev.map(p => {
      const matchId = (String(p.id) === String(data.pedido_id)) || (String(p.pedido_id) === String(data.pedido_id));
      return matchId ? { 
        ...p, 
        estado: 'completado', 
        estado_bridge: 'ENTREGADO',
        fecha_entrega: new Date().toISOString() 
      } : p;
    }));

    // 3. (Opcional) Si quieres un sonido o un alert nativo:
    // alert(`¡Pedido ${data.pedido_id} finalizado por el cliente!`);
  });


// nuevo --- en prueba -----------
adminRoomChannel.bind('cambio_estado_delivery', (data) => {
  console.log("🚀 Sincronizando estado de delivery:", data);
  setPedidos(prev => prev.map(p => {
    // Comparamos contra p.id o p.pedido_id para asegurar el match
    const matchId = (String(p.id) === String(data.pedido_id)) || (String(p.pedido_id) === String(data.pedido_id));
    return matchId ? { ...p, estado_bridge: data.estado_bridge } : p;
  }));
});


////////////////////


  // nuevo-pedido 

  channel.bind('nuevo-pedido', (data) => {
    const pedidoCrudo = {
      id: String(data.pedido_id || data.id),
      pedido_id: String(data.pedido_id || data.id),
      cliente_id: data.cliente_id,
      
      // ✅ USAMOS 'productos' PARA COINCIDIR CON PHP Y SQL
      productos: data.productos || [], 
      
      modo_entrega: data.modo_entrega || 'retiro',
      envio: { 
        direccion: data.direccion || 'Dirección no especificada',
        nombre: data.cliente_nombre || 'Cliente Nuevo'
      },
      estado: data.estado || 'pendiente',
      fecha: data.fecha || new Date().toISOString(),
      admin_id: data.admin_id || null
    };
  
    // 2. Normalización Maestra (Asegúrate de que esta función exista en tu componente)
    const pedidoParseado = parsePedidoFields(pedidoCrudo, mapaClientesRef.current);
  
    // 3. 🛡️ FILTRO DE SEGURIDAD (MODO PRUEBA: TRUE)
    // Hemos forzado 'true' para ignorar la validación de admin_id temporalmente
    const esParaEsteAdmin = true; 
    
    /* Lógica original comentada para pruebas:
    const esParaEsteAdmin = 
      !pedidoParseado.admin_id || 
      pedidoParseado.admin_id === null || 
      String(pedidoParseado.admin_id) === String(miAdminId);
    */
  
    if (esParaEsteAdmin) {
      setPedidos(prev => {
        // 4. Evitamos duplicados con comparación de Strings estricta
        const existe = prev.find(p => String(p.id) === String(pedidoParseado.id));
        
        if (existe) {
          console.log("⚠️ Pedido ya existe en la lista (ID: " + pedidoParseado.id + "), omitiendo duplicado.");
          return prev;
        }
  
        // 5. Inserción limpia al inicio de la lista
        console.log("✅ ¡ÉXITO! Agregando pedido a la vista en tiempo real:", pedidoParseado);
        return [pedidoParseado, ...prev];
      });
  
      // 6. Actualizamos el mapa de nombres
      if (typeof actualizarMapaClientes === 'function') {
        actualizarMapaClientes(pedidoParseado);
      }
      
      // 7. Alerta visual para estar 100% seguros de que entró
      console.log("🔔 Notificación: Se ha recibido un nuevo pedido de " + (pedidoParseado.envio?.nombre || "Usuario"));
  
    } else {
      // Este log ahora no debería salir porque esParaEsteAdmin es true
      console.log("ℹ️ Pedido ignorado: pertenece a otro administrador.");
    }
  });

  // ---------nuevo-pago ------

  channel.bind('nuevo-pago', async (data) => {
    console.log("💰 Pago detectado para pedido:", data.pedido_id);
    
    const idPedidoPago = String(data.pedido_id);
    const tokenReal = user?.token;

    // 1. Pequeña pausa (500ms) por seguridad de escritura
    await new Promise(resolve => setTimeout(resolve, 500));

    if (data.requiereCargaComprobante) {
        try {
            // --- 🌍 DETECTAR URL DE CONEXIÓN INTELIGENTE ---
            let URL_BASE = 'https://clavelinacarnes.com/clavelina-backend-php/public/api';
            try {
                if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) {
                    URL_BASE = import.meta.env.VITE_API_URL;
                } else if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) {
                    URL_BASE = process.env.REACT_APP_API_URL;
                }
            } catch (e) {
                URL_BASE = 'https://clavelinacarnes.com/clavelina-backend-php/public/api';
            }

            // 🎯 RUTA LIMPIA HÍBRIDA: Conectamos mediante la API unificada pasando el parámetro GET
            const urlPhp = `${URL_BASE}/admin/consultar_pago?pedido_id=${idPedidoPago}`;
            
            console.log(`🔍 Consultando comprobante en: ${urlPhp}`);

            const res = await fetch(urlPhp, {
                headers: { 'Authorization': `Bearer ${tokenReal}` }
            });

            if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
            
            const resultado = await res.json();
            
            // 📥 Extraemos el primer pago del array 'data' que devuelve PHP
            const pagoCompleto = (resultado.success && Array.isArray(resultado.data)) 
                ? resultado.data[0] 
                : null;

            if (pagoCompleto) {
                const pagoConDatos = {
                    ...data,
                    metodo: pagoCompleto.metodo, 
                    imagen: pagoCompleto.imagen, 
                    datos: pagoCompleto || {}, 
                    tiene_imagen: !!pagoCompleto.imagen,
                    requiereCarga: false
                };
                console.log("📸 Capture cargado con éxito desde PHP:", idPedidoPago);
                setPagoPendienteGlobal(pagoConDatos);
            }
        } catch (err) {
            console.error("⚠️ Falló carga de comprobante en PHP, usando data básica:", err);
            setPagoPendienteGlobal(data);
        }
    } else {
        setPagoPendienteGlobal(data);
    }

    // 2. ACTUALIZACIÓN DEL ESTADO DE PEDIDOS
    setPedidos(prev => prev.map(p => 
        String(p.id || p.pedido_id) === idPedidoPago 
        ? { ...p, pago_confirmado: true, estado: 'esperando_confirmacion' } 
        : p
    ));

    // 3. ACTUALIZACIÓN DEL PEDIDO SELECCIONADO
    setPedidoSeleccionado(prev => {
        if (prev && String(prev.id || prev.pedido_id) === idPedidoPago) {
            return { ...prev, pago_confirmado: true, estado: 'esperando_confirmacion' };
        }
        return prev;
    });
});

  channel.bind('bridge_actualizado', ({ pedido_id, estado_bridge }) => {
    setPedidos(prev => prev.map(p => (p.id || p.pedido_id) === pedido_id ? { ...p, estado_bridge } : p));
  });

  // 4. Limpieza: Se ejecuta al desmontar o cambiar usuario
  return () => {
    console.log("🧹 Desconectando Pusher...");
    if (channel) channel.unbind_all();
    if (pusher) {
      pusher.unsubscribe('admin-orders');
      pusher.disconnect();
    }
  };
}, [user?.uuid, user?.token]); //  BIEN: Depende del token actualizado


const onProcesarPedido = async (pedidoIdRecibido) => {
  const pedidoData = pedidos.find(p => String(p.pedido_id) === String(pedidoIdRecibido) || String(p.id) === String(pedidoIdRecibido));
  
  if (!pedidoData || !token || !miAdminId) return;

  const idParaEnviar = pedidoData.pedido_id || pedidoIdRecibido;

  try {
      console.log("ENVIANDO TOMAR PEDIDO:", {
        pedido_id: idParaEnviar,
        admin_id: miAdminId
      });
      
      // 🎯 SINCRO: Apuntamos al index.php unificado de producción en cPanel
      const urlProduccion = 'https://clavelinacarnes.com/clavelina-backend-php/public/index.php/public/api/pedidos/tomar';
      
      const response = await fetch(urlProduccion, {
          method: 'POST', 
          headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` 
          },
          body: JSON.stringify({ 
            pedido_id: idParaEnviar,
            admin_id: miAdminId 
        })
    });

      if (response.ok) {
          const resultado = await response.json();

          // ✅ ACTUALIZACIÓN LOCAL
          setPedidos(prev => prev.map(p => 
              (String(p.pedido_id) === String(idParaEnviar) || String(p.id) === String(idParaEnviar))
              ? { ...p, estado: 'procesando', admin_id: miAdminId } 
              : p
          ));
          
          if (pedidoSeleccionado && String(pedidoSeleccionado.id) === String(idParaEnviar)) {
              setPedidoSeleccionado(prev => ({ ...prev, estado: 'procesando', admin_id: miAdminId }));
          }

          alert("Pedido tomado correctamente por el Administrador.");
      } else {
          const errorData = await response.json();
          alert(`Error: ${errorData.error || 'No se pudo tomar el pedido'}`);
      }
  } catch (error) {
      console.error("❌ Error conectando con PHP:", error);
  }
};
// --- LÓGICA DE VALIDACIÓN Y FILTRADO ---
const esPedidoCompleto = (pedido) => {
  // 🚩 REGLA: Si tiene ID y modo de entrega, es un pedido válido para mostrar.
  // No nos importa validar la dirección aquí, eso se hace al crear el pedido.
  if (!pedido.id && !pedido.pedido_id) return false;
  if (!pedido.modo_entrega) return false;
  
  // Evitamos que cualquier lógica de 'envio' bloquee la visualización
  return true; 
};

const pedidosFiltrados = pedidos.filter(p => {
  let estado = (p.estado || '').toLowerCase();
  
  // 1. Normalización de estados terminados
  if (estado === ESTADOS_PEDIDO.CERRADO && p.modo_entrega === 'delivery') {
    estado = ESTADOS_PEDIDO.COMPLETADO;
  }

  // 2. Lógica por pestaña (Sencilla y Directa)
  let coincideEstado = false;

  if (filtro === 'delivery') {
    // 🚩 REGLA: Si es delivery y NO está en la papelera (rechazado), muéstralo SIEMPRE.
    // Esto incluye: Pendientes, Confirmados, En proceso, En ruta, etc.
    coincideEstado = p.modo_entrega === 'delivery' && !GRUPOS_ESTADOS.RECHAZADOS.includes(estado);
    
  } else if (filtro === 'pendientes') {
    // Solo lo que el Admin tiene que procesar (poner precio)
    coincideEstado = GRUPOS_ESTADOS.PENDIENTES.includes(estado);

  } else if (filtro === 'completados') {
    coincideEstado = GRUPOS_ESTADOS.COMPLETADOS.includes(estado);

  } else {
    // Filtro 'todos': Mostrar todo lo que no sea basura
    coincideEstado = true; 
  }

  // 3. Validaciones de seguridad y búsqueda
const coincideCliente = clienteIdBuscado
? p.cliente_id?.toLowerCase().includes(clienteIdBuscado.toLowerCase())
: true;

const completo = esPedidoCompleto(p);

// 🚩 CAMBIO AQUÍ: Forzamos que ambos sean String para que la comparación sea infalible
const esDelAdmin = !p.admin_id || 
                     p.admin_id === null || 
                     String(p.admin_id) === String(miAdminId);

  return coincideEstado && coincideCliente && completo && esDelAdmin;
});
  return (
    <div className="container py-3">
      {/* renderizado de sidebar */}
      <Sidebar 
        modo={`${modo} ${sidebarOpen ? "open" : ""}`} 
        setFiltro={setFiltro} 
        onLogout={handleLogout}
        setVista={setVista} 
        setSidebarOpen={setSidebarOpen} 
      />

      {/* cierra sidebar al hacer clic fuera */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <div className="container-fluid pt-3">
        {/* Fila superior: título + botón hamburguesa */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold text-white">Clavelina-Admin</h2>
          <button 
            className="btn btn-dark d-md-none" 
            type="button" 
            data-bs-toggle="collapse" 
            data-bs-target="#adminMenu"
          >
            ☰
          </button>
        </div>

        {/* Paneles métricos */}
        <div className="row g-3 ">
          <div className="col-12 col-sm-6 col-md-3">
            <div 
              className="p-3 rounded bg-danger shadow-sm text-white d-flex align-items-center"
              style={{ cursor: 'pointer' }}
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <i className="fas fa-user-circle fs-3 me-3"></i>
              <div className="text-truncate">
                <p className="mb-0 fw-bold text-truncate">{nombre}</p>
                <small>Menú principal</small>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 rounded bg-danger shadow-sm text-white d-flex align-items-center">
              <i className="fas fa-users fs-3 me-3"></i>
              <div>
                <p className="mb-0 fw-bold">Usuarios conectados</p>
                <small>{usuariosConectados} activos</small>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="p-3 rounded shadow-sm text-white bg-danger">
              <p className="mb-1 fw-bold">
                <i className="fas fa-chart-bar me-2"></i>
                Total pedidos
              </p>
              <div className="progress bg-light" style={{ height: '8px' }}>
                <div 
                  className="progress-bar bg-warning" 
                  role="progressbar" 
                  style={{ width: `50%` }}  
                  aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"
                ></div>
              </div>
              <small>{pedidos.length} pedidos</small>   
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3 d-flex justify-content-end align-items-center">
            <button className="btn btn-outline-dark btn-sm d-none d-md-block" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>

      {/* MENÚ MOBILE */}
      <div className="collapse d-md-none mb-3" id="adminMenu">
        <div className="card card-body bg-dark text-white">
          <div className="d-flex flex-wrap gap-2 mb-2">
            <button className={`btn ${filtro==='pendientes'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('pendientes')}>Pendientes</button>
            <button className={`btn ${filtro==='completados'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('completados')}>Completados</button> 
            <button className={`btn ${filtro==='todos'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('todos')}>Todos</button>
            <button className={`btn ${filtro==='delivery'?'btn-primary':'btn-outline-primary'}`} onClick={()=>setFiltro('delivery')}>Pedidos Delivery</button>
          </div>
        </div>
      </div>

      {/* Filtros Desktop */}
      <div className="d-none d-md-flex justify-content-start gap-2 mb-3">
        <button className={`btn ${filtro==='pendientes'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('pendientes')}>Pendientes</button>
        <button className={`btn ${filtro==='completados'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('completados')}>Completados</button>
        <button className={`btn ${filtro==='todos'?'btn-danger':'btn-outline-danger'}`} onClick={()=>setFiltro('todos')}>Todos</button>
        <button className={`btn ${filtro==='delivery'?'btn-primary':'btn-outline-primary'}`} onClick={()=>setFiltro('delivery')}>Pedidos Delivery</button>
      </div>

      {/* ALERTAS */}
      {confirmaciones.map((conf, idx) => (
        <div key={idx} className="alert alert-danger" style={{ color: 'white', backgroundColor: '#CC0000' }}>
          <i className="bi-check-circle-fill"></i>
          &nbsp;Pedido {conf.pedido_id || conf.cliente_id} confirmado: {conf.mensaje}
        </div>
      ))}

      {/* Buscador */}
      <h3 className="text-white">Pedidos recibidos</h3>
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar por cliente ID"
          value={clienteIdBuscado}
          onChange={e => setClienteIdBuscado(e.target.value)}
        />
      </div>

      <div className="row">
        <div className="col-12 col-md-6">
          <div className='card card-dark mb-2'>
            <div 
              className='card-header text-danger d-flex justify-content-between align-items-center' 
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenPedidos(prev => !prev)}
            >
              <h4 className='m-0'>Pedidos recibidos</h4>
              <span>{openPedidos ? '▲' : '▼'}</span>
            </div>
            {openPedidos && (
              <div className="card-body p-2">
                <PedidosLista
                  pedidos={pedidosFiltrados}             
                  filtro={filtro}
                  pedidoExpandidoId={pedidoExpandidoId}
                  setPedidoExpandidoId={setPedidoExpandidoId}
                  onSeleccionar={setPedidoSeleccionado}
                  onEliminar={eliminarPedidoDesdeAdmin}
                 
                  adminUUID={adminUUID}
                  moverPedidoACompletados={moverPedidoACompletados}
                  onNotificarListoBridge={onNotificarListoBridge}
                  onProcesarPedido={onProcesarPedido}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Render condicional según la vista */}
    {/* --- RENDER CONDICIONAL DE VISTAS --- */}
    <div className="main-content mt-4">
        {vista === "dashboard" && <h2>Dashboard (Bienvenido {nombre})</h2>}
        
        {vista === "pedidos" && (
          <PedidosLista
            pedidos={pedidosFiltrados}
            filtro={filtro}
            pedidoExpandidoId={pedidoExpandidoId}
            setPedidoExpandidoId={setPedidoExpandidoId}
            onSeleccionar={setPedidoSeleccionado}
            onEliminar={eliminarPedidoDesdeAdmin}
           
            adminUUID={adminUUID}
            moverPedidoACompletados={moverPedidoACompletados}
            onNotificarListoBridge={onNotificarListoBridge}
            onProcesarPedido={onProcesarPedido}
          />
        )}

        {/* PASAMOS EL ID DEL ÚLTIMO PAGO PARA QUE LA VISTA SE RECARGUE SOLA */}
     {/* Usamos un div con display para que el componente PagosView no se "muera" al cambiar de pestaña */}
     {vista === "pagos" && (
  <PagosView 
    ultimoPagoId={pagoPendienteGlobal?.pedido_id} 
    filtroPedidoId={pagoPendienteGlobal?.pedido_id}
  />
)}

        {vista === "clientes" && <ClientesView />}
        
        {vista === "pedidosFinalizados" && <PedidosView visible={true} filtro={filtro} />}
      </div>

      {/* --- DETALLE DEL PEDIDO SELECCIONADO (FLUJO RETIRO/DELIVERY) --- */}
      {pedidoSeleccionado && (
  <div className="row mt-4">
    <h4 className="text-white">
      Detalle de Pedido Activo
      {/* Mostrar badge si hay pago pendiente para este pedido --- revisar para eliminar o usarlo  */} 
      {pagoPendienteGlobal && 
       String(pagoPendienteGlobal.pedido_id) === String(pedidoSeleccionado.id) && (
         // codigo en revision ===============================================
        // pago pendiente global en revision---------------------------------------------
        <span className="badge bg-warning text-dark ms-2 animate__animated animate__flash">
          💳 PAGO PENDIENTE DE CONFIRMAR
        </span>
        // codigo en revision ===============================================
        //----------------------------------------------------------------------------------
      )}
    </h4>
    <PedidoCard
      pedido={pedidoSeleccionado}
      
      adminUUID={adminUUID}
      pagoPendienteGlobal={
        // Solo pasar si es para este pedido específico
        pagoPendienteGlobal && 
        String(pagoPendienteGlobal.pedido_id) === String(pedidoSeleccionado.id)
          ? pagoPendienteGlobal 
          : null
      }
      onPagoConfirmado={() => {
        // NO limpiar el pago aquí
        cargarPedidosPersistentes();
      }}
      
    />
  </div>
)}
    </div> // Fin del container principal
  );
}